export const requiredFieldMessages = {
  given_name: 'Enter first name. Field cannot be blank.',
  firstName: 'Enter first name. Field cannot be blank.',
  family_name: 'Enter last name. Field cannot be blank.',
  lastName: 'Enter last name. Field cannot be blank.',
  email: 'Enter valid email address. Field cannot be blank.',
  phone_number: 'Enter valid phone number. Field cannot be blank.',
  street: 'Enter address. Field cannot be blank.',
  city: 'Enter city. Field cannot be blank.',
  postalCode: 'Enter valid zipcode.',
  password: 'Enter valid password. Field cannot be blank.',
  currentPassword: 'Enter current password. Field cannot be blank.',
  newPassword: 'Enter new password. Field cannot be blank.',
  confirmPassword: 'Enter confirm password. Field cannot be blank.',
  loginPassword: 'Enter valid password. Field cannot be blank.',
  signUpPassword: 'Enter valid password. Field cannot be blank.',
};

export const validateFieldMessages = {
  email: 'Enter valid email address.',
  phone_number: 'Phone number must be 10 digits. (000) 000-0000',
  phoneNumber: 'Phone number must be 10 digits. (000) 000-0000',
  password: 'Enter valid password.',
  stateSelector: 'Select a state.',
  countrySelector: 'Select a country.',
};

export const customMessages = {
  usernameExistsException: 'An account with this email address already exists.Please <a href="/account/login" class="accent fw-bold-normal td-underline c-utility-red">login </a> or <a href="/account/reset-password" class="accent fw-bold-normal td-underline c-utility-red">reset your password</a>.',
  aliasExistsException: 'This email address is already in use, try another one.',
  authErrorCodeException: 'Code is incorrect. Please try again.',
  emptyErrorCodeException: 'Code cannot be empty. Please enter a valid code.',
  expiredCodeException: 'Code has expired. Try resending to receive a new code.',
};

export const warrantyInfoMessages = {
  warrantyInfoTitle: 'Rest easy with Purple',
  tenYearWarranty: '10-Year warranty',
  tenYearWarrantyAppliesTo: 'Applies to Mattresses and select bed frames',
  oneYearWarranty: '1-Year warranty',
  oneYearWarrantyAppliesTo: 'Applies to Pillows, Cushions, Bedding, and the Platform Bed Frame',
  oneHundredNightTrial: '100-Night trial',
  oneHundredNightTrialAppliesTo: 'Applies to Mattresses and Pillows',
  thirtyDayTrial: '30-Day trial',
  thirtyDayTrialAppliesTo: 'Applies to Seat Cushions',
  flexibleFinancingOptions: 'Flexible financing options',
  flexibleFinancingOptionsSub: 'As low as 0% APR',
  freeShipping: 'Free shipping',
  freeShippingSub: 'In the contiguous states',
  shieldIconAlt: 'Shield Icon',
  nighttimeIconAlt: 'Nighttime Icon',
  daytimeIconAlt: 'Daytime Icon',
  creditCardIconAlt: 'Credit Card Icon',
  deliveryIconAlt: 'Delivery Icon',
};
